import {AccountType} from "../model/AccountType";

export const isAdmin = (account?: AccountType | null): boolean => {
    // noinspection PointlessBooleanExpressionJS
    return !!(account &&
        account.permissions &&
        account.permissions.includes("Admin"));
};